var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[_c('div',{staticClass:"exercise"},[_c('h1',[_vm._v("Step 2")])])])}]

export { render, staticRenderFns }